<template>
  <!-- 音频专辑的列表 -->
  <div class="audio">
    <div class="audio_box">
      <!-- 音频查询 -->
      <el-card>
        <el-form :inline="true" label-width="120px" size="small">
          <el-row>
            <el-col :span="8">
              <el-form-item label="专辑名字">
                <el-input
                  placeholder="请输入内容"
                  v-model="searchData.name"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="描述">
                <el-input
                  placeholder="请输入内容"
                  v-model="searchData.description"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="出品方">
                <el-input
                  placeholder="请输入内容"
                  v-model="searchData.producer"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="是否热门">
                <el-select
                  placeholder="请选择"
                  v-model="searchData.isHot"
                  clearable
                >
                  <el-option
                    v-for="item in isHots"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="是否轮播">
                <el-select
                  placeholder="请选择"
                  v-model="searchData.isRotation"
                  clearable
                >
                  <el-option
                    v-for="item in isLuns"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="是否上猜你喜欢">
                <el-select
                  placeholder="请选择"
                  v-model="searchData.isLike"
                  clearable
                >
                  <el-option
                    v-for="item in isLikes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-row :span="8">
              <el-form-item label="状态">
                <el-select
                  clearable
                  placeholder="请选择"
                  size="small"
                  v-model="searchData.examineStatus"
                >
                  <el-option
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    v-for="item in newsStatus"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
          </el-row>

          <el-form-item>
            <el-button
              style="margin-left: 120px"
              type="primary"
              @click="audioSearch"
              v-if="menuPerm('audio:query')"
              >查询</el-button
            >
            <el-button
              style="margin-left: 20px"
              type="primary"
              @click="getAdd"
              v-if="menuPerm('audio:add')"
              >添加</el-button
            >
            <el-button
              style="margin-left: 20px"
              type="primary"
              @click="audioClear"
              >清空</el-button
            >
          </el-form-item>
        </el-form>
      </el-card>
      <!-- 音频列表 -->
      <el-card>
        <el-table
          border
          ref="multipleTable"
          style="width: 100%; flex: auto"
          tooltip-effect="light"
          :data="audioList"
          @selection-change="handleSelectionChange"
          :header-cell-style="getRowClass"
        >
          <el-table-column
            label="封面图"
            prop="frontCoverUrl"
            width="200px"
            height="200px"
            align="center"
          >
            <template slot-scope="{ row }">
              <div class="audio_img">
                <img :src="row.frontCoverUrl" alt />
              </div>
            </template>
          </el-table-column>

          <el-table-column
            label="专辑名字"
            prop="name"
            align="center"
            width="200px"
          >
            <template slot-scope="{ row }">
              <a-tooltip>
                <template slot="title">{{ row.name }}</template>
                <span class="news_title">{{ row.name }}</span>
              </a-tooltip>
            </template>
          </el-table-column>

          <el-table-column
            label="描述"
            prop="description"
            align="center"
            width="200"
          >
            <template slot-scope="{ row }">
              <a-tooltip>
                <template slot="title">{{ row.description }}</template>
                <span class="news_title">{{ row.description }}</span>
              </a-tooltip>
            </template>
          </el-table-column>

          <el-table-column
            prop="producer"
            label="出品方"
            align="center"
          ></el-table-column>

          <el-table-column
            prop="isHot"
            label="是否热门"
            align="center"
            width="150px"
          >
            <template slot-scope="{ row }">
              <div v-if="row.isHot == 0">否</div>
              <div v-if="row.isHot == 1">是</div>
            </template>
          </el-table-column>

          <el-table-column prop="isRotation" label="是否轮播" align="center">
            <template slot-scope="{ row }">
              <div v-if="row.isRotation == 0">否</div>
              <div v-if="row.isRotation == 1">是</div>
            </template>
          </el-table-column>

          <el-table-column
            prop="isLike"
            label="是否上猜你喜欢"
            align="center"
            width="120px"
          >
            <template slot-scope="{ row }">
              <div v-if="row.isLike == 0">否</div>
              <div v-if="row.isLike == 1">是</div>
            </template>
          </el-table-column>

          <el-table-column
            label="审核状态"
            prop="examineStatus"
            width="180px"
            align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="menuPerm('audio:submit_review')">
                <span v-if="row.examineStatus == 2">未提交审核</span>
                <span v-if="row.examineStatus == 3">审核中</span>
                <span v-if="row.examineStatus == 4">审核未通过</span>
                <span v-if="row.examineStatus == 1">审核通过</span>
              </div>

              <!-- 审核者r -->
              <el-select
                placeholder="请选择"
                v-model="row.examineStatus"
                v-if="menuPerm('audio:review')"
                @change="examChange($event, row)"
              >
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-for="item in revernewsStatus"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            class-name="small-padding fixed-width"
            label="操作"
            width="140px"
            fixed="right"
          >
            <template slot-scope="{ row }">
              <div class="done">
                <el-button
                  type="primary"
                  @click="audioDel(row.id)"
                  class="dels"
                  :disabled="
                    (row.examineStatus == 1 || row.examineStatus == 3) &&
                    allOpen
                      ? true
                      : false
                  "
                  v-if="menuPerm('audio:delete')"
                  >删除</el-button
                >
                <el-button
                  type="primary"
                  @click="audioXiang(row)"
                  v-if="menuPerm('audio:query')"
                  >详情</el-button
                >
                <el-button type="primary" @click="push(row)" v-if="menuPerm('app:push')">推送</el-button>

                <el-button
                  type="primary"
                  @click="submitExam(row.id)"
                  v-if="menuPerm('audio:submit_review')"
                  :disabled="
                    (row.examineStatus == 1 || row.examineStatus == 3) &&
                    allOpen
                      ? true
                      : false
                  "
                  >提交审核</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-row style="width: auto; marginright: 50px; margintop: 20px">
          <el-pagination
            :current-page="currentPage"
            :page-size="pagesize"
            :page-sizes="[5, 10, 15]"
            :total="totalCount"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></el-pagination>
        </el-row>
      </el-card>
      <!-- 详情页面 -->
      <a-drawer
        title="音频详情"
        :width="900"
        :visible="visible"
        :body-style="{ paddingBottom: '80px' }"
        @close="onClose"
      >
        <Detail :Detaildata="detailData" />
      </a-drawer>
    </div>
    <!-- 删除弹框 -->
    <a-modal
      title
      :visible="delOpen"
      @ok="handleOk"
      ok-text="确认"
      cancel-text="取消"
      @cancel="handleCancel"
    >
      <p>确认删除吗？</p>
    </a-modal>
  </div>
</template>
<script>
import Detail from "./edit";
export default {
  data() {
    return {
      detailData: "",
      visible: false,
      allOpen: true, //没有限制

      //查询数据：
      searchData: {
        //    authorId: this.searchData.authorId, //作者 id
        name: "", //专辑名字
        description: "", //描述
        frontCoverUrl: "", //封面图
        producer: "", //出品方
        isHot: "", //是否热门
        isRotation: "", //是否轮播
        isLike: "", //是否上猜你喜欢
        examineStatus: "", //审核状态
      },
      delOpen: false, //删除弹框

      audioList: [], //音频列表
      currentPage: 1,
      pagesize: 10,
      pageNum: 1,
      totalCount: 0,
      delId: "", //删除id
      author: "", //作者
      //是否热门:
      isHots: [
        {
          label: "否",
          value: "0",
        },
        {
          label: "是",
          value: "1",
        },
      ],
      //是否轮播:
      isLuns: [
        {
          label: "否",
          value: "0",
        },
        {
          label: "是",
          value: "1",
        },
      ],
      //是否上猜你喜欢
      isLikes: [
        {
          label: "否",
          value: "0",
        },
        {
          label: "是",
          value: "1",
        },
      ],

      //状态--下拉框：
      newsStatus: [
        {
          value: "2",
          label: "未提交审核",
        },
        {
          value: "3",
          label: "审核中",
        },
        {
          value: "4",
          label: "审核未通过",
        },
        {
          value: "1",
          label: "审核通过",
        },
      ],
      //状态--下拉框：
      revernewsStatus: [
        {
          value: 1,
          label: "审核通过",
        },
        {
          value: 3,
          label: "审核中",
        },
        {
          value: 4,
          label: "审核未通过",
        },
        {
          value: 2,
          label: "未提交审核",
        },
      ],
      shenExam: [
        {
          value: 1,
          label: "审核通过",
        },
        {
          value: 3,
          label: "审核中",
        },
      ],
      back: false,
    };
  },
  components: {
    Detail,
  },
  methods: {
    onClose() {
      this.visible = false;
    },
    //修改音频专辑的审核状态
    examChange(val, row) {
      this.getAxios("/audio/album/review", {
        id: row.id,
        examineStatus: val,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success("修改审核状态成功");
          this.getAudio();
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    //分页
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.getModile();
    },
    //分页：
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.getModile();
    },
    //分页
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //音频列表的查询：
    audioSearch() {
      this.currentPage = 1;

      this.postAxios("/audio/album/list", {
        pageNum: this.currentPage,
        pageSize: 10,
        authorId: "", //作者 id
        name: this.searchData.name, //专辑名字
        description: this.searchData.description, //描述

        producer: this.searchData.producer, //出品方
        isHot: this.searchData.isHot, //是否热门
        isRotation: this.searchData.isRotation, //是否轮播
        isLike: this.searchData.isLike, //是否上猜你喜欢
        examineStatus: this.searchData.examineStatus, //审核状态
      }).then((res) => {
        if (res.success == true) {
          this.audioList = res.content;
          this.totalCount = res.totalCount;
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //音频列表的清空：
    audioClear() {
      (this.searchData.name = ""), //专辑名字
        (this.searchData.description = ""), //描述
        (this.searchData.producer = ""), //出品方
        (this.searchData.isHot = ""), //是否热门
        (this.searchData.isRotation = ""), //是否轮播
        (this.searchData.isLike = ""), //是否上猜你喜欢
        (this.searchData.examineStatus = ""); //审核状态
    },
    //音频专辑的列表
    getAudio() {
      this.postAxios("/audio/album/list", {
        pageNum: this.currentPage,
        pageSize: 10,
        authorId: "", //作者 id
        name: this.searchData.name, //专辑名字
        description: this.searchData.description, //描述
        frontCoverUrl: "", //封面图
        producer: this.searchData.producer, //出品方
        isHot: this.searchData.isHot, //是否热门
        isRotation: this.searchData.isRotation, //是否轮播
        isLike: this.searchData.isLike, //是否上猜你喜欢
        examineStatus: this.searchData.examineStatus, //审核状态
      }).then((res) => {
        if (res.success == true) {
          this.audioList = res.content;
          this.totalCount = res.totalCount;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //音频专辑添加
    getAdd() {
      this.$router.push({ path: "/audioAdd" });
    },

    // 提交审核：
    submitExam(id) {
      this.getAxios("/audio/album/submit/review", {
        id: id, //专辑的id
      }).then((res) => {
        if (res.success == true) {
          this.$message.success("提交审核成功！");
          this.examOpen = true;
          this.getAudio();
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //音频专辑详情
    audioXiang(row) {
      this.visible = true;
      this.detailData = row;
    },
    // app推送
    push(row) {
      this.getAxios("/app/push", {
        type: 4,
        id: row.id,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success(res.message);
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (res.success == false && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //删除弹框取消
    handleCancel() {
      this.delOpen = false;
    },
    //音频专辑删除确认
    handleOk() {
      this.getAxios("/audio/album/delete", {
        id: this.delId,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success("删除成功！");
          this.delOpen = false;
          this.getAudio();
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //删除弹框出现：
    audioDel(id) {
      this.delId = id; //删除id
      this.delOpen = true;
    },
  },
  created() {
    this.getAudio(); //音频列表

    if (this.menuPerm("audio:edit_super") == true) {
      this.allOpen = false;
    }
  },
};
</script>
<style scoped lang="less">
.audio {
  width: 100%;
  height: 100%;
  .audio_box {
    width: 95%;
    height: auto;
    margin: 20px auto;
    .el-card {
      margin-top: 15px;
      .news_title {
        display: block;
        width: 170px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .audio_img {
        width: 200px;
        height: 150px;
        margin-left: -10px;
        display: table-cell;
        vertical-align: middle;
        text-align: center;

        img {
          width: 100%;
          height: auto;
        }
      }
      .done {
        display: flex;
        flex-direction: column;
        width: 100px;
        .dels {
          width: 50px;
        }
        /deep/ .el-button--primary {
          color: #fff;
          background-color: #409eff;
          border-color: #409eff;
          width: 100px;
          margin-top: 10px;
          margin-left: 10px;
          height: 30px;
          line-height: 5px;
          font-size: 12px;
        }
      }
      /deep/ .el-button--primary {
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
        width: 100px;
      }
    }
  }
}
</style>